import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const COUNTRY_VIDEO_REPORT_ID = `country${VIDEO_CAMPAIGN_SUFFIX}`;
